import { Component, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationDto } from '../../../notifications/notification.service';

@Component({
  selector: 'app-notifications-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notifications-panel.component.html',
  styleUrl: './notifications-panel.component.scss',
})
export class NotificationsPanelComponent {
  @Input() notifications: NotificationDto[] = [];
  @Input() loading: boolean = false;

  @Output() reviewStatusChange = new EventEmitter<NotificationDto>();
  @Output() notificationClick = new EventEmitter<NotificationDto>();

  constructor(public el: ElementRef<HTMLElement>) {}

  trackById(_i: number, n: NotificationDto) {
    return n.id;
  }
  isUnread(n: NotificationDto): boolean {
    return (n.notification_status || '').toUpperCase() === 'NEW';
  }

  onReviewStatusChange(notification: NotificationDto) {
    this.reviewStatusChange.emit(notification);
  }

  onNotificationClick(notification: NotificationDto, _event: MouseEvent) {
    // Emit event to parent component for handling mark as read and navigation
    this.notificationClick.emit(notification);
  }
}
